import { getAudioContext, isMutedGlobal } from './sound.js';

/** Bright two-note bell when someone calls the Janlii (respects the shared mute preference). */
export function playJanliiCallSound() {
  if (isMutedGlobal()) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  const now = ctx.currentTime;
  [[880, 0], [1318.5, 0.12]].forEach(([freq, delay]) => {
    const t0 = now + delay;
    for (const [mult, vol] of [[1, 0.16], [2.76, 0.05]]) {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq * mult, t0);
      gain.gain.setValueAtTime(0.001, t0);
      gain.gain.linearRampToValueAtTime(vol, t0 + 0.008);
      gain.gain.exponentialRampToValueAtTime(0.001, t0 + 0.9);
      osc.connect(gain); gain.connect(ctx.destination);
      osc.start(t0); osc.stop(t0 + 0.92);
    }
  });
}

/** Short slide across the felt and a stacked clack when someone takes a stack from the ring. */
export function playStackPickSound() {
  if (isMutedGlobal()) return;
  const ctx = getAudioContext();
  if (!ctx) return;
  const now = ctx.currentTime;
  const length = Math.floor(ctx.sampleRate * 0.14);
  const buffer = ctx.createBuffer(1, length, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < length; i++) data[i] = Math.random() * 2 - 1;
  const slide = ctx.createBufferSource();
  slide.buffer = buffer;
  const filter = ctx.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.setValueAtTime(700, now);
  filter.frequency.exponentialRampToValueAtTime(2200, now + 0.12);
  const slideGain = ctx.createGain();
  slideGain.gain.setValueAtTime(0.001, now);
  slideGain.gain.linearRampToValueAtTime(0.07, now + 0.03);
  slideGain.gain.exponentialRampToValueAtTime(0.001, now + 0.14);
  slide.connect(filter); filter.connect(slideGain); slideGain.connect(ctx.destination);
  slide.start(now); slide.stop(now + 0.14);
  [0.13, 0.16].forEach((offset, i) => {
    const t0 = now + offset;
    const body = ctx.createOscillator();
    const gain = ctx.createGain();
    body.type = 'triangle';
    body.frequency.setValueAtTime(480 - i * 40, t0);
    body.frequency.exponentialRampToValueAtTime(170, t0 + 0.045);
    gain.gain.setValueAtTime(0.15, t0);
    gain.gain.exponentialRampToValueAtTime(0.001, t0 + 0.055);
    body.connect(gain); gain.connect(ctx.destination);
    body.start(t0); body.stop(t0 + 0.06);
  });
}
